import { useState, useCallback } from 'react';
import { UseMutationResult } from '@tanstack/react-query';
import * as axios from 'axios';
import { CustomerQueryDto, NubUserDTO } from "@/shared/api/model";

export const useUsers = (branch: string) => {
    const [searchTerm, setSearchTerm] = useState('');

    // Search users function using direct axios call
    const searchUsers = useCallback(async (params: Partial<CustomerQueryDto>) => {
        const searchParams = {
            searchTerm: params.searchKey || '',
            groupCode: params.groupCode
        };
        const response = await axios.default.get<NubUserDTO[]>('/frontend/admin/scale-users/search', {
            params: searchParams
        });
        return response.data;
    }, []);

    // Update user profile function - uses the NubUserController endpoint
    const updateUserProfile = useCallback(async (userData: { userId: string; profilePath: string }) => {
        const response = await axios.default.put<NubUserDTO>(`/api/nub/users/${userData.userId}`, {
            profilePath: userData.profilePath
        });
        return response.data;
    }, []);

    return {
        users: [] as NubUserDTO[],
        isLoading: false,
        error: null as Error | null,
        searchUsers,
        updateUserProfile,
        searchTerm,
        setSearchTerm,
    };
};

export function useUserSearch() {
    // Use the direct axios function since this is a mutation pattern
    // but useSearchUsers is a query hook
    return {
        mutateAsync: async (searchTerm: string) => {
            if (!searchTerm || searchTerm.length < 2) return [];
            const response = await axios.default.get<NubUserDTO[]>('/frontend/admin/scale-users/search', {
                params: { searchTerm }
            });
            return response.data;
        }
    } as UseMutationResult<NubUserDTO[], Error, string>;
}